import { readStoredJson, removeStoredKey, writeStoredJson } from '../storage';
import { STORAGE_KEY } from './catalog/storage';
import { decodeConfig } from './decode';
import type { RcuConfig } from './model';
import { createEmptyConfig } from './model';

/**
 * The configuration lives only on this device. Nothing here is authoritative:
 * if storage is unavailable the app still runs from the in-memory store.
 */
export const loadStoredConfig = (now: string): RcuConfig => {
  const raw = readStoredJson(STORAGE_KEY.CONFIG);
  if (raw === null) return createEmptyConfig(now);

  const decoded = decodeConfig(raw, now);
  if (decoded === null) {
    console.warn('RCU config: stored data was not readable and has been ignored.');
    return createEmptyConfig(now);
  }
  if (decoded.droppedRecords > 0) {
    console.warn(`RCU config: ignored ${decoded.droppedRecords} unreadable record(s).`);
  }
  return decoded.config;
};

export const saveStoredConfig = (config: RcuConfig): void => {
  writeStoredJson(STORAGE_KEY.CONFIG, config);
};

export const clearStoredConfig = (): void => {
  removeStoredKey(STORAGE_KEY.CONFIG);
};
